import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconArrowDown } from '../../../../../assets/svg/invoices-icons/icon-arrow-down.svg';
import { InvoiceSettingsContext } from '../../contexts/InvoiceSettingsContext';
import { HUB_MODALS } from '../InvoiceHubModals';
import { useStore } from '../../../../../store';

interface IProps {
  shouldDisable?: boolean;
}

export const InvoiceSettings = ({ shouldDisable }: IProps) => {
  const setActiveModal = useStore(state => state.setActiveModal);
  const activeModal = useStore(state => state.activeModal);
  const { t } = useTranslation();
  const { setInvoiceSettingsReferenceElement } = useContext(InvoiceSettingsContext);
  const onMoreActionsClick = (e: any) => {
    e.stopPropagation();
    setActiveModal(HUB_MODALS.INVOICE_SETTINGS);
  };
  return (
    <button
      disabled={shouldDisable}
      type='button'
      ref={setInvoiceSettingsReferenceElement}
      onClick={onMoreActionsClick}
      data-testid='invoice-hub__settings-button'
      className='h-[40px] w-[134px] mr-[12px] justify-center flex items-center cursor-pointer pl-[14px] pr-[10px]'
    >
      <div data-testid='invoice-hub__settings-button__text' className={`flex font-metricRMedium text-[14px] ${shouldDisable ? 'text-bw05' : 'text-bw08'}`}>{t('INVOICE_SETTINGS.MORE_ACTIONS')}</div>
      <IconArrowDown data-testid='invoice-hub__settings-button__arrow' className={`${shouldDisable ? 'stroke-bw05 text-bw05' : 'stroke-action03 text-action03'} ${activeModal === HUB_MODALS.INVOICE_SETTINGS ? 'rotate-180 relative top-[2px]' : ''}`} />
    </button>
  );
};
